module.exports = __webpack_public_path__ + "img/ManCave.e4f74a0f.jpeg";